import React, { FC } from 'react';

import styles from './dropdown_search_folders.module.scss';
import { withFolderDropdown } from '../../../FoldersDropdownContext';
import { FoldersDropdownContextType } from '../../../foldersDropdown.types';

type Props = {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocusAndBlur: () => void;
  searchValue: string;
  focus: boolean;
} & FoldersDropdownContextType;

export const RawDropdownSearchFolders: FC<Props> = ({
  handleChange,
  handleFocusAndBlur,
  searchValue,
  focus,
  errorMessage,
}) => (
  <div className={styles.container}>
    <div className={`${styles.group} ${focus ? styles.focus : styles.blur}`}>
      <span className={styles.icon} />
      <input
        autoFocus
        value={searchValue}
        className={styles.input}
        onChange={handleChange}
        onFocus={handleFocusAndBlur}
        onBlur={handleFocusAndBlur}
        placeholder="Chercher"
      />
    </div>
    {errorMessage && (
      <div className={`form-error is-visible ${styles.error}`}>
        {errorMessage}
      </div>
    )}
  </div>
);

export const DropdownSearchFolders = withFolderDropdown(
  RawDropdownSearchFolders,
);
